export const FETCH_INDUSTRIES_BEGIN = 'FETCH_INDUSTRIES_BEGIN';
export const FETCH_INDUSTRIES_DONE = 'FETCH_INDUSTRIES_DONE';
export const FETCH_FEATUREDINDUSTRIES_BEGIN = 'FETCH_FEATUREDINDUSTRIES_BEGIN';
export const FETCH_FEATUREDINDUSTRIES_DONE = 'FETCH_FEATUREDINDUSTRIES_DONE';
export const RECEIVE_FEATURED_INDUSTRIES = 'RECEIVE_FEATURED_INDUSTRIES';
export const RECEIVE_INDUSTRIES = 'RECEIVE_INDUSTRIES';

